import React, { useRef, useContext } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { DataTable } from 'primereact/datatable';
import { useSnapshots } from '../Queries';
import { SnapshotContext, SnapshotDispatchContext } from '../SnapshotContext';




export default function SnapshotSelect() {
    const { isPending, error, data } = useSnapshots();
    const currentSnapshot = useContext(SnapshotContext);
    const dispatch = useContext(SnapshotDispatchContext);
    
    const op = useRef(null);
    const toast = useRef(null);

    const snapSelect = (e) => {
        op.current.hide();
        toast.current.show({ severity: 'info', summary: 'Wybrano bazę danych', detail:e.data.snap_name, life: 3000 }); 
    };

    const statusBodyTemplate = (snap) => {
        return <Tag value={getStatusName(snap)} severity={getSeverity(snap)}></Tag>;
    };

    
    const getSeverity = (snap) => {
        switch (snap.snap_status) {
            case 0:
                return 'success';

            case 1:
                return 'danger';

            case 2:
                return 'info';

            default:
                return null;
        }
    };

    const getStatusName = (snap) => {
        switch (snap.snap_status) {
            case 0:
                return 'projektowana';

            case 1:
                return 'aktualna';

            case 2:
                return 'archiwalna';

            default:
                return null;
        }
    };    


    if(isPending){
        return;
    }

    if(error){
        return;
    }

    return (
        <div className="card flex flex-column align-items-center gap-3">
            <Toast ref={toast} position="top-center" />
            <Button size="small" type="button" icon="fa-solid fa-database" label={currentSnapshot.snap_name} severity={getSeverity(currentSnapshot)} onClick={(e) => op.current.toggle(e)} />
            <OverlayPanel ref={op} showCloseIcon closeOnEscape dismissable={false}>
                    <DataTable value={data} selectionMode="single" paginator rows={5}  selection={currentSnapshot} onSelectionChange={(e) => {(e.value) ? dispatch({type:"changed",selectedSnapshot:e.value}) : false}}  onRowClick={snapSelect} >
                        <Column field="snap_prefix" header="ID" sortable style={{ minWidth: '5rem' }} />
                        <Column field="snap_name" header="Name" sortable style={{ minWidth: '12rem' }} />
                        <Column field="snap_description" header="Opis" sortable style={{ minWidth: '12rem' }} />
                        <Column field="snap_status" header="Status" sortable style={{ minWidth: '4rem' }} body={statusBodyTemplate} />
                        <Column field="snap_creation_date" header="Utworzona" sortable style={{ minWidth: '12rem' }} />
                    </DataTable>
            </OverlayPanel>
        </div>
    );
}
         